import { Metrics, MetricsEntries } from "~/lib/arrow";
import { useDailyCounts } from "./useDailyCounts";

export interface UseDailyPriorityFindingCountsParams {
  entityMrn: string;
  numOfDays?: number;
  entries?: MetricsEntries;
}

export function useDailyPriorityFindingCounts({
  entityMrn,
  numOfDays = 28,
  entries,
}: UseDailyPriorityFindingCountsParams) {
  return useDailyCounts({
    entityMrn,
    numOfDays,
    metricMrn: Metrics.HistoricalDailyFindingCount,
    getCount(d) {
      return d.critical + d.high;
    },
    entries,
  });
}
